/*
 * @Author: your name
 * @Date: 2021-06-03 10:39:51
 * @LastEditTime: 2021-06-03 10:46:53
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \fm-client\src\plugins\base.js
 */
exports.install = function (Vue, options) {
    Vue.prototype.msg = function (msg, type) {
        this.$notify({
            title: '提示',
            message: msg,
            type: type ? type : 'warning'
        });
    };
};


// WEBPACK FOOTER //
// ./src/plugins/base.js